import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconExpandHorizontal$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconExpandHorizontal extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '297d1395b7b4d4b2a25c507cbca1cfdae93a9fc5', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '54c1b79000512de81c33dbbed9d30d67c13696ce', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6a53a2670ba78d703ad0782b3b9330d60382f7ba', d: "M15 13.482c0 .444.541.682.887.389l2.93-2.482a.506.506 0 0 0 0-.778l-2.93-2.482c-.346-.293-.887-.055-.887.39zM11.25 3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5zM6.113 8.129c.346-.293.887-.055.887.39v4.963c0 .444-.541.682-.887.389l-2.93-2.482a.507.507 0 0 1 0-.778z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-expand-horizontal", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-expand-horizontal"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-expand-horizontal":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconExpandHorizontal$1);
            }
            break;
    } });
}

const CosmosIconExpandHorizontal = CosmosIconExpandHorizontal$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconExpandHorizontal, defineCustomElement };
